import React, { useState, forwardRef } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import EventInfoCard from './EventInfoCard';
import StartNumberSearch from './StartNumberSearch';
import ExtendedSearch from '../extended-search/ExtendedSearch';

import { FormattedMessageWrappedInSpan } from '../../misc';

const EventOnlineView = forwardRef((props, ref) => {
  const {
    onlineEvent,
    onExpandBestof,
    bestOfAvailable,
    extendedSearchSelectedCategoryId,
    showSearchInstructionsDialog,
    extendedSearchSelectedTab,
    extendedSearchExpand,
    onExtendedSearchTabChange,
    onExtendedSearchExpand,
    hasSmartSearchTab,
    hasCategorySearchTab,
    hasGpsSearchTab,
    hasDualSearchTab,
    hasExtendedSearch,
    onSearchTrigger
  } = props;

  const [startNumber, setStartNumber] = useState(props.urlSn || '');
  const [searchStartNumber, setSearchStartNumber] = useState(props.urlSearchSn);
  const [secondFactor, setSecondFactor] = useState(props.customerKey ? window.atob(props.customerKey) : '');

  const isSNSearchPage = (
    props.match.path === '/:language/event/:id/search/:startnumber'
    || props.match.path === '/:language/event/:id/search/:startnumber/:customerKey'
  )

  const handleInputChange = (name, value) => {
    switch (name) {
      case "startNumber": setStartNumber(value); break;
      case "secondFactor": setSecondFactor(value); break;
    }
  };

  const handleExtendedSearchHintClosed = () => {
    if (!extendedSearchExpand) {
      onExtendedSearchExpand()
    }
  };

  return (
    <div ref={ref}>
      <div className="row">
        <EventInfoCard
          eventInfo={onlineEvent}
          onExpandBestof={onExpandBestof}
          bestOfAvailable={bestOfAvailable}
          eventBannerActAsLink={true}
        />
        <StartNumberSearch
          info={onlineEvent}
          onInputChange={handleInputChange}
          onSearchTrigger={onSearchTrigger}
          onExtendedSearchHintClosed={handleExtendedSearchHintClosed}
          startNumber={startNumber}
          secondFactor={secondFactor}
          showSearchInstructionsDialog={showSearchInstructionsDialog}
        />
      </div>
      {hasExtendedSearch && (
        <>
          <ExtendedSearch
            startnumber={startNumber}
            searchStartnumber={searchStartNumber}
            event={onlineEvent}
            selectedCategoryId={extendedSearchSelectedCategoryId}
            selectedTab={extendedSearchSelectedTab}
            expand={extendedSearchExpand}
            onTabChange={onExtendedSearchTabChange}
            onExpand={onExtendedSearchExpand}
            hasSmartSearchTab={hasSmartSearchTab}
            hasCategorySearchTab={hasCategorySearchTab}
            hasGpsSearchTab={hasGpsSearchTab}
            hasDualSearchTab={hasDualSearchTab}
          />
          {isSNSearchPage && (
            <div className="row">
              <div className="col-xs-16 col-sm-12 col-sm-offset-2">
                <div
                  className="extended-search-expand"
                  onClick={onExtendedSearchExpand}
                >
                  {!extendedSearchExpand && (
                    <>
                      <div className="extended-search-expand-desktop">
                        <FormattedMessageWrappedInSpan
                          id="extendedSearch.morePhotosDesktop"
                          defaultMessage="+ Are there more photos of me?"
                        />
                      </div>
                      <div className="extended-search-expand-mobile">
                        <FormattedMessageWrappedInSpan
                          id="extendedSearch.morePhotosMobile"
                          defaultMessage="More?"
                        />
                      </div>
                    </>
                  )}
                  {extendedSearchExpand && (
                    <>
                      <div className="extended-search-expand-desktop">
                        <FormattedMessageWrappedInSpan
                          id="extendedSearch.hideMorePhotosDesktop"
                          defaultMessage="- Hide extended search options"
                        />
                      </div>
                      <div className="extended-search-expand-mobile">
                        <FormattedMessageWrappedInSpan
                          id="extendedSearch.hideMorePhotosMobile"
                          defaultMessage="Hide"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
});

EventOnlineView.defaultProps = {
  hasExtendedSearch: true,
  urlSearchSn: ""
};

EventOnlineView.propTypes = {
  match: PropTypes.object,
  extendedSearchSelectedCategoryId: PropTypes.string,
  urlSn: PropTypes.string,
  urlSearchSn: PropTypes.string,
  customerKey: PropTypes.string,
  bestOfAvailable: PropTypes.bool,
  extendedSearchExpand: PropTypes.bool,
  hasSmartSearchTab: PropTypes.bool,
  hasCategorySearchTab: PropTypes.bool,
  hasGpsSearchTab: PropTypes.bool,
  hasDualSearchTab: PropTypes.bool,
  hasExtendedSearch: PropTypes.bool,
  showSearchInstructionsDialog: PropTypes.bool,
  extendedSearchSelectedTab: PropTypes.number,
  onlineEvent: PropTypes.object,
  onExpandBestof: PropTypes.func,
  onExtendedSearchTabChange: PropTypes.func,
  onExtendedSearchExpand: PropTypes.func,
  onSearchTrigger: PropTypes.func,
};

export { EventOnlineView };

export default createFragmentContainer(withRouter(EventOnlineView), {
  onlineEvent: graphql`
    fragment EventOnlineView_onlineEvent on Event {
      id
      sgId
      hostResultUrl
      name
      ...EventInfoCard_eventInfo
      ...StartNumberSearch_info
      ...ExtendedSearch_event
    }
  `,
});
